import React from 'react';


const AddressList = (props) => {
  const { styles } = props;
  return (
    <div className={`${styles.account_card}`}>
      <span onClick={() => {props.activeTab('')}}>back</span>
      <div className={`${styles.card_head}`}>
        <div className={`${styles.card_title}`}>Saved addresses</div>
      </div>
      <div className={`${styles.card_body}`}>
         
      </div>
    </div>
  )
}

export default AddressList